import { Component, OnInit } from '@angular/core';
import { ContentService } from '../../shared/content.service';

@Component({
  selector: 'app-experian',
  templateUrl: './experian.component.html',
  styleUrls: ['./experian.component.scss']
})
export class ExperianComponent implements OnInit {
  page: Object;

  constructor(private contentService: ContentService) {
  }

  ngOnInit() {
    this.page = this.contentService.pages['experian'];
  }

}
